<template>
    <div
        class="row toolbar justify-content-between"
        data-cy="toolbar"
    >
        <div
            class="col-12 col-lg-auto mb-2 mb-lg-0 d-flex flex-column flex-lg-row align-items-stretch align-items-lg-center align-content-between toolbar-buttons"
            data-cy="toolbarActionButtons"
        >
            <!-- Buttons used to initiate actions. e.g. Opening an add item form -->
            <slot name="action-buttons" />
        </div>

        <div
            class="col-12 col-lg-auto d-flex flex-column flex-lg-row align-items-center toolbar-filters"
            data-cy="toolbarFilters"
        >
            <div
                class="col-12 col-lg-auto mb-2 mb-lg-0 p-0 d-flex flex-column flex-shrink-1 flex-lg-row align-items-stretch align-items-lg-center filter-buttons"
                data-cy="toolbarFilterButtons"
            >
                <!-- Buttons used for filtering of the list items -->
                <slot name="filter-buttons" />
            </div>

            <div
                v-if="!hideSearch"
                id="toolbarSearch"
                class="col-12 col-lg-auto ml-0 ml-lg-2 d-block search"
                data-cy="toolbarFilterSearch"
            >
                <div class="input-group">
                    <input
                        id="searchText"
                        v-model="textSearch"
                        class="form-control"
                        data-cy="toolbarFilterSearchInput"
                        placeholder="search..."
                        type="search"
                        @keyup.enter="searchText"
                    >

                    <div class="input-group-append">
                        <button
                            class="btn btn-primary btn-search"
                            data-analytics-label="Search Button"
                            :data-analytics-location="`${analyticsPrefix} Toolbar`"
                            data-cy="toolbarFilterSearchButton"
                            type="button"
                            aria-label="Search"
                            @click="searchText"
                        >
                            <FontAwesomeIcon
                                icon="search"
                                data-analytics-label="Search Button"
                                :data-analytics-location="`${analyticsPrefix} Toolbar`"
                                data-cy="toolbarFilterSearchButtonIcon"
                            />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSearch } from '@fortawesome/pro-solid-svg-icons';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    library.add(faSearch);

    /**
     * @group List View Components
     */
    export default {
        name: 'LToolbar',
        components: {
            FontAwesomeIcon,
        },
        props: {
            // Gets prefixed to all analytic attributes on elements that users interact with
            analyticsPrefix: {
                type: String,
                required: true
            },
            // Whether the search box should be hidden or not.
            hideSearch: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                textSearch: '',
            };
        },
        methods: {
            searchText() {
                // Emitted when text is entered to search
                // @arg Text entered by user
                this.$emit('text-search', this.textSearch);
                this.textSearch = '';
            }
        }
    };
</script>

<style
    lang="sass"
    scoped
>
    .toolbar
        background-color: var(--kc-gray-400)
        padding: 0.5rem
        position: relative
        z-index: 1021

        p
            &.text-note
                margin: 0
                padding: 0.375rem 0.75rem
                font-style: italic

        .toolbar-buttons
            padding: 0

        .toolbar-filters
            padding: 0

            .search
                padding: 0

                .form-control
                    padding: 0.5rem 0.25rem

                    &:focus
                        border-color: var(--kc-blue-500)

                .search-filter-selection
                    .btn::after
                        display: none

                    .btn-light
                        background-color: #fff
                        color: var(--kc-blue-500)

                        &:hover
                            background-color: darken(#fff, 10)
                            color: var(--kc-gray-900)

    body.mode.dark
        .toolbar
            background-color: var(--kc-blue-800)
</style>
